const initialState = {
  logs: [],
  user: {},
  showLoader: false,
};

const auditsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_AUDITS':
      return {
        ...state,
        ...action.payload,
      };
    case 'LOADING_ACTION':
      return {
        ...state,
        showLoader: action.payload,
      };
    default:
      return { ...state };
  }
};
export default auditsReducer;
